module.exports = __webpack_public_path__ + "static/p07_borreguitoLLegFrontRTop-7721df66501f6bff2ee75a243d848c5d.png";